import { EngineDetailModal } from "../modals/EngineDetailModal";
import { ConfirmModal } from "../modals/ConfirmModal";
import { NotificationModal } from "../modals/NotificationModal";

export const modalRegistry = {
  engineDetail: EngineDetailModal,
  confirm: ConfirmModal,
  notification: NotificationModal
} as const;